import React from "react";
import { Zoom } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";
import prayagraj3 from "../assets/prayagraj3.jpeg";
import prayagraj4 from "../assets/prayagraj4.jpeg";
import prayagraj5 from "../assets/prayagraj5.jpeg";
import { FaPalette } from "react-icons/fa";
import { IoIosPeople } from "react-icons/io";
import { HiCurrencyRupee } from "react-icons/hi2";

const fadeImages = [
  { src: prayagraj4, alt: "Slide 4" },
  { src: prayagraj3, alt: "Slide 3" },
  { src: prayagraj5, alt: "Slide 5" },
];

const Slideshow = () => {
  return (
    <div className="relative w-full min-h-screen">
      {/* Background Slideshow */}
      <div className="absolute inset-0 z-0 overflow-hidden">
        <Zoom scale={1.1} duration={1800} infinite={true} pauseOnHover={false}>
          {fadeImages.map((fadeImage, index) => (
            <div key={index} className="w-full h-screen">
              <img
                src={fadeImage.src}
                alt={fadeImage.alt}
                className="w-full h-full object-cover"
              />
            </div>
          ))}
        </Zoom>
      </div>

      {/* Overlay Content */}
      <div
        className="absolute inset-0 flex flex-col justify-center items-center text-center text-white bg-black bg-opacity-50 z-10 p-4"
        style={{ fontFamily: "Tiro Devanagari Hindi, serif" }}
      >
        <h1 className="text-3xl md:text-5xl lg:text-6xl mb-4">Prayagraj</h1>
        <p className="text-sm md:text-lg lg:text-xl mb-8">
          The City of Triveni Sangam and Spiritual Bliss
        </p>

        <div className="flex flex-wrap justify-center gap-4 p-4">
          <InfoBox icon={<FaPalette size="3rem" color="#ffffff" />} title="Theme" description="Spirituality / Heritage" />
          <InfoBox icon={<span className="text-3xl md:text-4xl">📏</span>} title="Area" description="5,482 km²" />
          <InfoBox icon={<IoIosPeople size="3rem" color="#ffffff" />} title="Population" description="5.9 million" />
          <InfoBox icon={<HiCurrencyRupee size="3rem" color="#ffffff" />} title="Currency" description="Indian Rupee" />
        </div>
      </div>
    </div>
  );
};

const InfoBox = ({ icon, title, description }) => (
  <div className="flex flex-col items-center mb-4">
    {icon}
    <p className="text-lg mt-2">{title}</p>
    <p className="text-sm">{description}</p>
  </div>
);

export default Slideshow;
